//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { AccessControl } from "@careinfo/merchant-permission-service";
//@ts-ignore
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import EditIcon from "../../Icons/EditIcon";
import TrashIcon from "../../Icons/TrashIcon";
import Button from "../Reusable/Button";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import Modal from "../Reusable/Modal";
import { hasAccess } from "../../utils/permission";
import { getKey } from "../../helpers/sessionKey";
import moment from "moment";
import { ColumnDef } from "@tanstack/react-table";
import { FormLayout } from "@careinfo/layout";
import CourierPickupRequestForm from "./PickupRequestForm";
import { createPickupRequestValidationForm } from "../../utils/validationSchemas";
import VehicleForm from "../VehicleForm";
import DriverForm from "../DriverForm";

const CreatePickupRequest = (props: any) => {
  const {
    handleCreate,
    handleCreatePickup,
    isLoading,
    handleRemove,
    isRemoving,
    openDeletePopup,
    setDeletePopup,
    userPermissions,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    openAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
    profile,
  } = props;
  const [selectedCount, setSelectedCount] = useState(0);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
    reset,
  } = useForm<any>({
    resolver: yupResolver(createPickupRequestValidationForm),
  });
  useEffect(() => {
    if (profile) {
      reset({
        sender_name: profile?.profile?.full_name ?? "",
        sender_primary_contact: profile?.mobile_number ?? "",
        sender_address: profile?.address?.name ?? "",
      });
    }
  }, [profile, reset]);
  useEffect(() => {
    setValue("order_count", selectedCount ?? 0, {
      shouldDirty: true,
      shouldValidate: true,
    });
  }, [selectedCount, setValue]);
  const [searchParams, setSearchParms] = useSearchParams();
  const [removeId, setRemoveId] = useState<null | string>(null);

  const handleRemoveClick = () => {
    setDeletePopup(true);
  };

  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };
  const handleOrderEditNavigate = (value: any) => {
    window.location.replace(`order#/edit/${value}`);
  };
  const handleCargoEditNavigate = (value: any) => {
    window.location.replace(`order#/list/edit/${value}`);
  };

  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const defaultCargoColumns: ColumnDef<any, any>[] = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`cursor-pointer focus:outline-none`}>
            <p className={tw`whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
            <p className={tw`text-xs text-red-500`}>
              {row?.original?.invoice_print_count ? "Printed" : null}
            </p>
          </div>
        );
      },
    },

    {
      header: "Date",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <p className={tw`max-w-[80px]`}>
                {moment(getValue()).format("YY-MM-DD HH:mm:ss")}
              </p>
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      header: "Forwarding No.",
      accessorKey: "forwarding_no",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "sender.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.sender?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.receiver?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Country",
      accessorKey: "receiver.country",
      cell: NACell,
    },
    {
      header: "Piece",
      accessorKey: "total_piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "charge_wt",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    // {
    //   header: "Remarks",
    //   accessorKey: "remark",
    //   cell: ({ row, getValue }: any) => (
    //     <button
    //       onClick={() => {
    //         setSelectedOrder(row?.original?.id);
    //         setOpenReviewModal(true);
    //       }}
    //     >
    //       {getValue()} Remarks
    //     </button>
    //   ),
    // },
    {
      header: "Created By",
      accessorKey: "created_by",
      cell: NACell,
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{
                background: row?.original?.delivery_status?.color,
              }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Hub",
      accessorKey: "hub.name",
      cell: NACell,
    },
    {
      header: "P. Type",
      accessorKey: "reference_type.name",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <AccessControl allowedPermissions={["can_editupdate_consignment"]}>
          <div className={tw`grid grid-cols-2 items-end`}>
            <button
              className={tw`focus:outline-none h-4 w-4`}
              type="button"
              onClick={() => handleCargoEditNavigate(getValue())}
            >
              <EditIcon color={"var(--primary)"} />
            </button>
            <button
              className={tw`focus:outline-none h-6 w-6`}
              type="button"
              onClick={() => {
                setRemoveId(getValue());
                handleRemoveClick();
              }}
            >
              <TrashIcon color={"var(--primary)"} />
            </button>
          </div>
        </AccessControl>
      ),
    },
  ];

  let defaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Ref No.",
      accessorKey: "reference_number",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Destination",
      accessorKey: "destination.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs `}>
              {row?.original?.receiver?.primary_contact}
            </p>
            <p className={tw`text-xs  `}>{row?.original?.receiver?.address}</p>
          </>
        );
      },
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className="whitespace-nowrap">
              COD: {row?.original?.cod ?? 0.0}
            </p>
            <p className="whitespace-nowrap">
              Collected: {row?.original?.collected_cod ?? 0.0}
            </p>
            <p className="whitespace-nowrap">D. Charge:{getValue()}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()}
              <span className="text-gray-500 text-xs">
                {row?.original?.package_type?.unit}
              </span>{" "}
            </p>
          </>
        );
      },
    },
    ...(hasAccess(["can_view_merchant_piece"], userPermissions)
      ? [
          {
            header: "Piece",
            accessorKey: "piece",
            cell: ({ getValue }: any) => (
              <p>
                {getValue() ?? "0"}
                <span className="text-gray-500 text-xs"></span>
              </p>
            ),
          },
        ]
      : []),
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => <p>{getValue()} Remarks</p>,
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: "#1C90E9" }}
            >
              Draft
            </p>
          </>
        );
      },
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <AccessControl allowedPermissions={["can_editupdate_consignment"]}>
          <div className={tw`grid grid-cols-2 items-end`}>
            <button
              className={tw`focus:outline-none h-4 w-4`}
              type="button"
              onClick={() => handleOrderEditNavigate(getValue())}
            >
              <EditIcon color={"var(--primary)"} />
            </button>
            <button
              className={tw`focus:outline-none h-6 w-6`}
              type="button"
              onClick={() => {
                setRemoveId(getValue());
                handleRemoveClick();
              }}
            >
              <TrashIcon color={"var(--primary)"} />
            </button>
          </div>
        </AccessControl>
      ),
    },
  ];

  const filterParams = watch();

  const handleEditNavigate = (row: any) => {
    console.error("");
  };

  const clientType = getKey("client-type");
  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreatePickup}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <CourierPickupRequestForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          setOpenAddDriverPopup={setOpenAddDriverPopup}
          setOpenAddVehiclePopup={setOpenAddVehiclePopup}
          watch={watch}
          control={control}
        />
      </FormLayout>
      <DataTable
        url={APIS.ORDER}
        queryKey={"orders"}
        columns={clientType === "cargo" ? defaultCargoColumns : defaultColumns}
        tableName={"create-pickup-request"}
        handleEditNavigate={handleEditNavigate}
        onSelectedCountChange={setSelectedCount}
        params={{
          is_draft: true,
        }}
        // actionMenu={
        //   <>
        //     <div className={tw`flex justify-end w-full items-center`}>
        //       <div className={tw`w-[100px] mr-4`}>
        //         <Button
        //           label={'Create'}
        //           onClick={() => handleCreate(setError)}
        //           isLoading={isLoading}
        //           disabled={false}
        //         />
        //       </div>
        //     </div>
        //   </>
        // }
      />

      <Modal
        isOpen={openDeletePopup}
        setIsOpen={() => {
          setDeletePopup(false);
          setRemoveId(null);
        }}
      >
        <div className={tw`flex flex-col justify-center items-center  h-fit`}>
          <p className={tw`text-lg font-semibold mb-4`}>
            Are you sure you want to delete ?
          </p>
          <div className={tw`grid grid-cols-2 place-items-center gap-x-4`}>
            <div className={tw`w-24`}>
              <Button
                label={"Yes, Remove"}
                isLoading={isRemoving}
                disabled={isRemoving}
                onClick={() => handleRemove(removeId)}
              />
            </div>
            <button
              type="button"
              className={tw`w-full px-[24px] py-2  rounded  focus:outline-none bg-[#EEF5F4]`}
              onClick={() => {
                setDeletePopup(!openDeletePopup);
                setRemoveId(null);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
    </>
  );
};

export default CreatePickupRequest;
